import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons/download-gray.svg'
import _imports_1 from '@/assets/img/icons/delete-gray.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0afc40e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-between mb-4" }
const _hoisted_3 = { class: "text-xl text-blue-900 font-semibold leading-6 tracking-wide mb-2" }
const _hoisted_4 = { class: "shadow-sm p-4 mb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl text-blue-900 mb-4" }, "User Detail", -1))
const _hoisted_6 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Nama Lengkap", -1))
const _hoisted_8 = { class: "customer-detail__value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Status", -1))
const _hoisted_10 = { class: "customer-detail__value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Tempat Lahir", -1))
const _hoisted_12 = { class: "customer-detail__value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Tanggal Lahir", -1))
const _hoisted_14 = { class: "customer-detail__value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Email", -1))
const _hoisted_16 = { class: "customer-detail__value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Nomor Telepon", -1))
const _hoisted_18 = { class: "customer-detail__value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Provinsi", -1))
const _hoisted_20 = { class: "customer-detail__value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Jenis Kelamin", -1))
const _hoisted_22 = { class: "customer-detail__value" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Pendidikan Terakhir", -1))
const _hoisted_24 = { class: "customer-detail__value" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Institusi Pendidikan", -1))
const _hoisted_26 = { class: "customer-detail__value" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Tanggal Mulai", -1))
const _hoisted_28 = { class: "customer-detail__value" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Tahun Terakhir", -1))
const _hoisted_30 = { class: "customer-detail__value" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Pekerjaan Saat Ini", -1))
const _hoisted_32 = { class: "customer-detail__value" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Bidang / Industri", -1))
const _hoisted_34 = { class: "customer-detail__value" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, " Pengalaman Bekerja (Dalam Tahun) ", -1))
const _hoisted_36 = { class: "customer-detail__value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Status Perkawinan", -1))
const _hoisted_38 = { class: "customer-detail__value" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Tanggal Mulai Akses", -1))
const _hoisted_40 = { class: "customer-detail__value" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-detail__label" }, "Tanggal Selesai Akses", -1))
const _hoisted_42 = { class: "customer-detail__value" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900 mb-2" }, " List Assesment ", -1))
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_49 = [
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_badge = _resolveComponent("badge")!
  const _component_table_lite = _resolveComponent("table-lite")!
  const _component_delete_test_participant_modal = _resolveComponent("delete-test-participant-modal")!

  return (Object.keys(_ctx.state.participantDetail).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_back_button),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.state.participantDetail.participant.email), 1),
            _createVNode(_component_badge, {
              variant: _ctx.getBadgeVariant(_ctx.state.participantDetail.project.status),
              label: _ctx.state.participantDetail.project.status_label
            }, null, 8, ["variant", "label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.state.participantDetail.user?.name || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.state.participantDetail.customer?.status || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.state.participantDetail.customer?.place_of_birth_label || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatDateTime(
                _ctx.state.participantDetail.customer?.date_of_birth,
                "YYYY-MM-DD"
              ) || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.state.participantDetail.participant.email || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.state.participantDetail.user?.phone || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.state.participantDetail.customer?.province?.name || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.state.participantDetail.customer?.gender || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.state.participantDetail.customer?.last_education || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.state.participantDetail.customer?.institution?.name || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.state.participantDetail.customer?.last_education_from_year || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.state.participantDetail.customer?.last_education_to_year || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.state.participantDetail.customer?.profession || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.state.participantDetail.customer?.industry?.name || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.state.participantDetail.customer?.work_experience_year || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.state.participantDetail.customer?.marital_status || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formatDateTime(
                _ctx.state.participantDetail.project.started_at,
                "YYYY-MM-DD"
              ) || "-"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.formatDateTime(
                _ctx.state.participantDetail.project.ended_at,
                "YYYY-MM-DD"
              ) || "-"), 1)
            ])
          ])
        ]),
        _hoisted_43,
        _createVNode(_component_table_lite, {
          "is-slot-mode": true,
          "is-loading": _ctx.table.isLoading,
          columns: _ctx.table.columns,
          rows: _ctx.table.rows,
          total: _ctx.table.totalRecordCount,
          sortable: _ctx.table.sortable,
          onDoSearch: _ctx.doSearch,
          onIsFinished: _ctx.tableLoadingFinish
        }, {
          result: _withCtx((data) => [
            _createTextVNode(_toDisplayString(data.value.result || "-"), 1)
          ]),
          action: _withCtx((data) => [
            (data.value.result)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.downloadResult(data.value.id))
                }, _hoisted_46, 8, _hoisted_44))
              : _createCommentVNode("", true),
            (data.value.status === 'Unopened')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: ($event: any) => (_ctx.actionDelete(data.value.id))
                }, _hoisted_49, 8, _hoisted_47))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["is-loading", "columns", "rows", "total", "sortable", "onDoSearch", "onIsFinished"]),
        _createVNode(_component_delete_test_participant_modal, {
          ref: "showDeleteModal",
          onOnSuccess: _ctx.doSearch
        }, null, 8, ["onOnSuccess"])
      ]))
    : _createCommentVNode("", true)
}